import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function RouteListener() {
  const location = useLocation();
  // const navigate = useNavigate();
  useEffect(() => {
    // Send the current path to the parent window
    window.parent.postMessage({ path: location.pathname }, "*");
  }, [location]);

  return null; // This component doesn't render anything
}

export default RouteListener;
